<template>
  <div class="content">
    <div class="page">
      <h2>研判分析</h2>
      <div class="message">
        以人、事、物、地址、组织等为要素，全面汇集整合小区各类信息资源，使用数据分析和挖掘技术，建立相应的实战应用模型，通过数据碰撞，挖掘出能够提示犯罪运行和变化趋势方向的情报信息，提高小区的安全度。
      </div>
      <img
        src="../../../../assets/image/residentialQuartersImg/蒙版组 151.png"
        alt=""
      />
    </div>
  </div>
</template>
 
<script>
export default {
  components: {},
  name: "",
  data() {
    return {};
  },

  methods: {},
};
</script>
 
<style scoped lang="scss">
.content {
  padding: 0 16%;
  box-sizing: border-box;
  min-height: calc(100vh - 387px);
  width: 100%;
  margin-bottom: 50px;
  .page {
    margin-top: 50px;
    width: 100%;
    height: 720px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px;
    // position: relative;
    text-align: center;
    > h2 {
      text-align-last: left;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin: 10px 0 30px 0;
    }
    .message {
      text-align-last: left;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6b6b6b;
      margin-bottom: 50px;
    }
  }
}
</style>